module.exports = __webpack_public_path__ + "img/icono_G6.9fc53785.svg";